export default "__VITE_ASSET__BQh1aZq$__"